import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeAccountCardLook = 'account-card-strip';

export const isWedgeAccountCardLook = (look: string | undefined): look is WedgeAccountCardLook => look === 'account-card-strip';

/* Released RepXP strip at the foot of the You tab account card: one full-width button that holds block children (the level row and the bar). It is a
   block with 14px above it and 14px of padding, no border but a 1px top rule in the card border role, a transparent fill, left-aligned text, the
   ink and the font of its parent, and a pointer cursor. It reads the exact legacy roles and keeps the declaration order of the source.
   It draws no transparent target and no anchor (wedgeSettingsDrawsHit, and a `content: none` rule naming the look): the button spans the card
   and is about 100px tall, so a 44px region could only repeat the box, and an anchor would turn the text of the whole row into a stacking
   context. The caller keeps the `wedge-pressable` class. */
const GAP = 14;

export function wedgeAccountCardStyle(_look: WedgeAccountCardLook): CSSProperties {
  const r = wedgeExactRole;
  return {
    display: 'block', width: '100%', marginTop: GAP, paddingTop: GAP,
    border: 'none', borderTop: `1px solid ${r('cardBorder')}`,
    background: 'transparent', textAlign: 'left', cursor: 'pointer',
    color: 'inherit', font: 'inherit',
  };
}
